const doc = [({"name":"Clippy", "summary":"Clippy is linter for Rust code", "icon":"clippy", "repositories":[({"rust-lang/rust-clippy":"good first issue"})]})];
module.exports = doc.length <= 1 ? doc[0] : doc;